// Debug JSON data for local testing
// Access via URL: /DEBUG/<jsonName>

export const debugData = {
  'test1': {
    "meta": {
      "status": "success"
    },
    "data": {
      "items": [
        {
          "qty": 4800,
          "job": [
            {
              "qty": 4800,
              "orderNumber": "2208197",
              "id": 1823904
            }
          ],
          "warehouse": "Magazijn 30",
          "available": 4480,
          "status": "Gereed",
          "locations": [
            {
              "warehouse": "Magazijn 30",
              "available": 4600,
              "location": "A.5.11",
              "locationId": 23703
            }
          ],
          "orderNumber": "2208197",
          "description": "M014787C003 (MMT-2758-2IT)",
          "articleCode": "M014787C003_1",
          "location": "A.0.10",
          "id": 1823904,
          "paperid": "14997",
          "locationId": 23583
        },
        {
          "qty": 3800,
          "job": [
            {
              "qty": 3800,
              "orderNumber": "2208197",
              "id": 1823904
            }
          ],
          "warehouse": "Magazijn 30",
          "available": 4480,
          "status": "Gereed",
          "locations": [
            {
              "warehouse": "Magazijn 30",
              "available": 4600,
              "location": "A.5.11",
              "locationId": 23703
            }
          ],
          "orderNumber": "2208190",
          "description": "M014787C003 (MMT-2758-2IT)",
          "articleCode": "M014787C003_1",
          "location": "A.0.10",
          "id": 1823904,
          "paperid": "14997",
          "locationId": 23583
        },
        {
          "qty": 500,
          "job": [
            {
              "qty": 500,
              "orderNumber": "2208197",
              "id": 1823905
            }
          ],
          "warehouse": "Magazijn 30",
          "available": 2000,
          "status": "Gereed",
          "locations": [
            {
              "warehouse": "Magazijn 30",
              "available": 1500,
              "location": "A.5.11",
              "locationId": 23703
            }
          ],
          "orderNumber": "2208190",
          "description": "M014787C002 (SAME LOCATION)",
          "articleCode": "M014787C002_1",
          "location": "A.0.10",
          "id": 1823905,
          "paperid": "14998",
          "locationId": 23583
        },
        {
          "qty": 1080,
          "job": [
            {
              "qty": 1080,
              "orderNumber": "2208196",
              "id": 1823915
            }
          ],
          "warehouse": "Magazijn 30",
          "available": 200,
          "status": "Gereed",
          "locations": [
            {
              "warehouse": "Magazijn 30",
              "available": 200,
              "location": "F.2.10",
              "locationId": 24474
            },
            {
              "warehouse": "Magazijn 30",
              "available": 200,
              "location": "F.2.12",
              "locationId": 24475
            },
            {
              "warehouse": "Magazijn 30",
              "available": 200,
              "location": "F.2.14",
              "locationId": 24477
            },
            {
              "warehouse": "Magazijn 30",
              "available": 200,
              "location": "F.2.15",
              "locationId": 24478
            },
            {
              "warehouse": "Magazijn 30",
              "available": 200,
              "location": "F.2.13",
              "locationId": 24476
            }
          ],
          "orderNumber": "2208196",
          "description": "M014784C006 (MMT-2742-2NL)",
          "articleCode": "M014784C006_1",
          "location": "F.2.11",
          "id": 1823915,
          "paperid": "14996",
          "locationId": 24473
        }
      ],
      "picklist": {
        "key": "4706234C-3CBF-4C08-965D-00470D40FB89",
        "date": "23-8-2024 9:49"
      }
    }
  }, "test2": {
    meta: {
      status: "success"
    },
    data: {
      items: [
        {
          qty: 0,
          job: [
            {
              qty: 0,
              orderNumber: "2650210",
              id: 21113962
            }
          ],
          warehouse: "Magazijn 30",
          available: 10500,
          status: "Gereed",
          locations: [
            {
              warehouse: "Printman",
              available: 815500,
              location: "a.01.0",
              locationId: 25105
            },
            {
              warehouse: "Magazijn 30",
              available: 42000,
              location: "E.2.03",
              locationId: 24343
            }
          ],
          orderNumber: "2650210",
          description: "C5 vensterenvelop VL couverteerbaar PostNL (nieuw logo) 31-07-2017is het laatste IJKPUNT na issues over voorraad aantallen (met het opboeken van 1.028.000 ex.) ",
          articleCode: "C5003-PostNL",
          location: "E.0.02",
          id: 21113962,
          paperid: "14375",
          locationId: 24265
        },
        {
          qty: 0,
          job: [
            {
              qty: 0,
              orderNumber: "2650210",
              id: 21113963
            }
          ],
          warehouse: "Magazijn 30",
          available: 40000,
          status: "Gereed",
          locations: [],
          orderNumber: "2650210",
          description: "uitnodiging Baarmoeder. 2021-S (nieuw logo) ",
          articleCode: "A0016",
          location: "E.0.03",
          id: 21113963,
          paperid: "14377",
          locationId: 24266
        },
        {
          qty: 0,
          job: [
            {
              qty: 0,
              orderNumber: "2650210",
              id: 21113960
            }
          ],
          warehouse: "Magazijn 30",
          available: 40000,
          status: "Gereed",
          locations: [
            {
              warehouse: "Van der Most",
              available: 678000,
              location: "A103",
              locationId: 12225
            },
            {
              warehouse: "Magazijn 30",
              available: 100000,
              location: "C.3.01",
              locationId: 24109
            }
          ],
          orderNumber: "2650210",
          description: "Briefpapier (met vlaggen) ",
          articleCode: "A0002",
          location: "E.0.04",
          id: 21113960,
          paperid: "17694",
          locationId: 24267
        }
      ],
      picklist: {
        key: "3F393098-D0ED-43DF-B9C8-A1B783CE8847",
        date: "2/3/2026 14:47"
      }
    }
  }
};
